function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import actions from './actions';
export var toggleDrawer = name => /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.toggleDrawer(name));
  });
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
export var closeDrawer = () => /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.toggleDrawer(null));
  });
  return function (_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var toggleSearch = () => /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.toggleSearch());
  });
  return function (_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var setIpLatLng = payload => /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.setIpLatLng(payload));
  });
  return function (_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var setOpenStoreModal = payload => /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.setOpenStoreModal(payload));
  });
  return function (_x5) {
    return _ref5.apply(this, arguments);
  };
}();
export var setStoreModalSingleProductId = payload => /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.setStoreModalSingleProductId(payload));
  });
  return function (_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export var setCurrentStore = payload => /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.setCurrentStore(payload));
  });
  return function (_x7) {
    return _ref7.apply(this, arguments);
  };
}();
export var setOpenSearchBar = payload => /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.setOpenSearchBar(payload));
  });
  return function (_x8) {
    return _ref8.apply(this, arguments);
  };
}();
export var setSearchBarValue = payload => /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.setSearchBarValue(payload));
  });
  return function (_x9) {
    return _ref9.apply(this, arguments);
  };
}();
export var setProductBadges = payload => /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.setProductBadges(payload));
  });
  return function (_x10) {
    return _ref10.apply(this, arguments);
  };
}();
export var setStoreConfig = payload => /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator(function* (dispatch) {
    return dispatch(actions.setStoreConfig(payload));
  });
  return function (_x11) {
    return _ref11.apply(this, arguments);
  };
}();
export var setPreferenceCookies = payload => /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setPreferenceCookies(payload));
  });
  return function (_x12) {
    return _ref12.apply(this, arguments);
  };
}();
export var closeAutocomplete = () => /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator(function* (dispatch, getState) {
    var {
      app: {
        openSearchBar
      }
    } = getState();
    if (openSearchBar) {
      dispatch(actions.setOpenSearchBar(false));
      dispatch(actions.setSearchBarValue(""));
    }
  });
  return function (_x13, _x14) {
    return _ref13.apply(this, arguments);
  };
}();